import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const spotTradeHistorySchema = z.object({
  /** Fill ID */
  id: z.string(),
  /** Fill Time */
  create_time: z.string(),
  /** Trading time, with millisecond precision */
  create_time_ms: z.string(),
  /** Currency pair */
  currency_pair: z.string(),
  /** Buy or sell order (`buy` / `sell`) */
  side: z.union([z.literal('buy'), z.literal('sell')]),
  /** Trade role, not returned in public endpoints (`taker` / `maker`) */
  role: z.union([z.literal('taker'), z.literal('maker')]).optional(),
  /** Trade amount */
  amount: decimalSchema,
  /** Order price */
  price: decimalSchema,
  /** Related order ID, not returned in public endpoints */
  order_id: z.string(),
  /** Fee deducted, not returned in public endpoints */
  fee: decimalSchema.optional(),
  /** Fee currency unit, not returned in public endpoints */
  fee_currency: z.string().optional(),
  /** Points used to deduct fee, not returned in public endpoints */
  point_fee: decimalSchema.optional(),
  /** GT used to deduct fee, not returned in public endpoints */
  gt_fee: decimalSchema.optional(),
  /** The custom data that the user remarked when amending the order */
  amend_text: z.string().optional(),
  /** Consecutive trade ID within a single market. Used to track and identify trades in the specific market */
  sequence_id: z.string().optional(),
  /** User-defined information, not returned in public endpoints */
  text: z.string().optional(),
})

export const responseSchema = z.array(spotTradeHistorySchema)
